module.exports = __webpack_public_path__ + "img/co2-modell.74e14a11.jpg";